<template>
  <header class="site-header">
    <div class="promo-bar">Free shipping on orders over $50 | New men's arrivals weekly</div>
    <div class="nav-shell">
      <router-link class="brand" to="/">GearPulse</router-link>
      <nav class="main-nav">
        <router-link to="/" :class="{ 'nav-active': isHomeActive }">Home</router-link>
        <router-link to="/items" :class="{ 'nav-active': isShopActive }">Shop</router-link>
        <router-link
          v-for="category in featuredCategories"
          :key="category"
          :to="{ path: '/items', query: { category } }"
          :class="{ 'nav-active': activeCategory === category }"
        >
          {{ categoryLabel(category) }}
        </router-link>
      </nav>
      <div class="nav-actions">
        <router-link to="/login">Account</router-link>
        <router-link class="cart-link" to="/bag">Bag <span>{{ cartCount }}</span></router-link>
      </div>
    </div>
  </header>
</template>

<script>
import { categories } from '@/data/products'
import { getCartCount } from '@/utils/cart'

export default {
  name: 'SiteHeader',
  data() {
    return {
      cartCount: getCartCount(),
      featuredCategories: categories.slice(0, 5)
    }
  },
  computed: {
    activeCategory() {
      return this.$route.path === '/items' ? this.$route.query.category || '' : ''
    },
    isHomeActive() {
      return this.$route.path === '/'
    },
    isShopActive() {
      return this.$route.path === '/items' && !this.$route.query.category
    }
  },
  mounted() {
    window.addEventListener('cart-change', this.refreshCart)
  },
  beforeDestroy() {
    window.removeEventListener('cart-change', this.refreshCart)
  },
  methods: {
    refreshCart() {
      this.cartCount = getCartCount()
    },
    categoryLabel(category) {
      return category.replace(' + ', ' ')
    }
  }
}
</script>
